import React from "react";
import styles from "./About.module.css";
import kiteVideo from "../../../video/aboutVideo.mp4";
import mer from "../../../img/mer.svg";
import merVertical from "../../../img/merVertical.png";
import { useEffect } from "react";

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className={styles.video_container}>
        <video className={styles.video} autoPlay playsInline loop muted>
          <source src={kiteVideo} type="video/mp4" />
        </video>
        <div className={styles.aboutUsImage}></div>
        <h1 className={styles.title + " text-center"}>ABOUT THIS PROJECT</h1>
        <div className={styles.transition}></div>
      </div>
      <div className="row d-flex justify-content-center p-0 mb-5 g-0 me-0">
        <div className="col-8">
          <div className={styles.content}>
            <h1 className={styles.subtitle}>ABOUT</h1>
            <p className={styles.font_size}>
              This e-commerce site is a project that four students of Hack
              Academy's Coding Bootcamp worked on for three weeks, dedicating
              more than 200 hours each.
            </p>
            <p className={styles.font_size}>
              The Bootcamp is an extremely practical 3-month full-time
              educational program, where we invested more than 600 hours
              learning about Node.js, Express, React.js, SQL, MongoDB and Git.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.row_container + " row"}>
        <div className={styles.card_container + " col-sm-12 col-md-6 col-lg-4"}>
          <div className={styles.card_content}>
            <h1 className={styles.subtitle}>DURATION</h1>
            <p className={"mt-3 " + styles.font_size}>
              The project was developed in approximately 3 weeks, it started on
              November 8th with its presentation and was handed in on November
              25th. During this time we divided the tasks into sprints,
              following the SCRUM methodology we used during the Bootcamp.
              Because of the time we had available we defined an MVP and later
              we added some improvements.
            </p>
          </div>
        </div>

        <div className={styles.card_container + " col-sm-12 col-md-6 col-lg-4"}>
          <div className={styles.card_content}>
            <h1 className={styles.subtitle}>TASKS</h1>
            <div className="d-flex align-items-center">
              <p className={"mt-3 " + styles.font_size}>
                For the tasks organization during this project, the tool used
                was Trello. First we determined all the tasks necessary to
                achieve the MVP and then we designated the daily tasks that each
                one had to carry out. This allowed each team member to be
                permanently aware of the status of the project as well as the
                tasks to be performed.
              </p>
            </div>
          </div>
        </div>
        <div className={styles.card_container + " col-sm-12 col-md-6 col-lg-4"}>
          <div className={styles.card_content}>
            <h1 className={styles.subtitle}>TECHNOLOGIES</h1>
            <p className={"mt-3 " + styles.font_size}>
              These are the technologies used to carry out the project:
            </p>
            <ul className={styles.about_ul}>
              <li className={styles.about_li}>HTML5</li>
              <li className={styles.about_li}>CSS3</li>
              <li className={styles.about_li}>React</li>
              <li className={styles.about_li}>Redux</li>
              <li className={styles.about_li}>Node.js</li>
              <li className={styles.about_li}>Express.js</li>
              <li className={styles.about_li}>MongoDB</li>
              <li className={styles.about_li}>Mongoose</li>
              <li className={styles.about_li}>Git/GitHub</li>
              <li className={styles.about_li}>Bootstrap</li>
              <li className={styles.about_li}>Trello</li>
              <li className={styles.about_li}>Figma</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center row me-0">
        <div className={styles.mer_container + " col-8"}>
          <h1 className={styles.subtitle + " mb-0 mt-5"}>ER MODEL</h1>
          <p className={styles.mer_content}>
            This entity relationship model that we diagram, outlines the
            structure and the information that will exist in our project's
            database. As well as the way in which the entities relate to each
            other.
          </p>
          <img className={styles.mer_img} src={mer} alt="mer" />
          <img
            className={styles.mer_vertical_img}
            src={merVertical}
            alt="mer"
          />
        </div>
      </div>
      <div className="container p-0">
        <div className="row mt-5 ms-0 p-0  d-flex justify-content-around w-100">
          <div
            className={
              "col-12 col-md-6 col-lg-2  d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ajiqazkcryxehovhfvhe.supabase.co/storage/v1/object/public/images/manuel.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Manuel Duarte</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="https://www.linkedin.com/in/manuelduartebotti/"
                className={styles.contact_us + " me-2"}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a
                href="https://github.com/duarte896"
                className={styles.contact_us}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
          <div
            className={
              "col-12 col-md-6 col-lg-2 d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ajiqazkcryxehovhfvhe.supabase.co/storage/v1/object/public/images/luciano.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Luciano Rodríguez</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="https://www.linkedin.com/in/luciano-ro-ar/"
                className={styles.contact_us + " me-2"}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a
                href="https://github.com/luchorodr"
                className={styles.contact_us}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
          <div
            className={
              "col-12 col-md-6 col-lg-2 d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ajiqazkcryxehovhfvhe.supabase.co/storage/v1/object/public/images/ignacio.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Ignacio Debat</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="https://www.linkedin.com/in/ignacio-debat/"
                className={styles.contact_us + " me-2"}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a
                href="https://github.com/IgnacioDebat"
                className={styles.contact_us}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
          <div
            className={
              "col-12 col-md-6 col-lg-2 d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ajiqazkcryxehovhfvhe.supabase.co/storage/v1/object/public/images/foto_lucia-2.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Lucía Collazzi</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="https://www.linkedin.com/in/lucia-collazzi/"
                className={styles.contact_us + " me-2"}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a
                href="https://github.com/lucia-collazzi"
                className={styles.contact_us}
                target={"_blank"}
                rel="noreferrer"
              >
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={"container  p-0 " + styles.row_container}>
        <div className="row mt-5  d-flex justify-content-around  p-0">
          <div
            className={
              "col-12 col-md-6 col-lg-2  d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ozonekites.com/wp-content/uploads/2022/10/1adriano.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Manuel Duarte</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="www.linkedin.com"
                className={styles.contact_us + " me-2"}
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://github.com" className={styles.contact_us}>
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
          <div
            className={
              "col-12 col-md-6 col-lg-2 d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ozonekites.com/wp-content/uploads/2022/10/1adriano.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Luciano Rodríguez</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="www.linkedin.com"
                className={styles.contact_us + " me-2"}
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://github.com" className={styles.contact_us}>
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
          <div
            className={
              "col-12 col-md-6 col-lg-2 d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ozonekites.com/wp-content/uploads/2022/10/1adriano.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Ignacio Debat</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="www.linkedin.com"
                className={styles.contact_us + " me-2"}
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://github.com" className={styles.contact_us}>
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
          <div
            className={
              "col-12 col-md-6 col-lg-2 d-flex flex-column align-items-center " +
              styles.team_div
            }
          >
            <img
              src="https://ozonekites.com/wp-content/uploads/2022/10/1adriano.jpg"
              alt=""
              className={styles.team_img}
            />
            <h2 className={styles.team_member_name}>Lucía Collazzi</h2>
            <h6 className={styles.team_member_subtitle}>
              Full Stack Developer
            </h6>
            <div>
              <a
                href="www.linkedin.com"
                className={styles.contact_us + " me-2"}
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://github.com" className={styles.contact_us}>
                <i className="fa-brands fa-square-github"></i>
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
